import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'

/**
 * Écoute les messages postMessage envoyés par l'extension (content script)
 * après ajout d'un produit au panier. Invalide les queries pour que la liste
 * des items et des paniers se mette à jour automatiquement sans rafraîchir la page.
 */
export default function ExtensionSyncListener() {
  const queryClient = useQueryClient()

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.source !== 'extension') return

      if (event.data.type === 'ITEM_ADDED_TO_CART') {
        const { cartId } = event.data.data || {}
        if (cartId != null) {
          const id = String(cartId)
          queryClient.invalidateQueries({ queryKey: ['items', id] })
          queryClient.invalidateQueries({ queryKey: ['carts'] })
          queryClient.refetchQueries({ queryKey: ['items', id] })
          queryClient.refetchQueries({ queryKey: ['carts'] })
        }
      }

      if (event.data.type === 'ITEM_PRICE_UPDATED') {
        const { cartId } = event.data.data || {}
        if (cartId != null) {
          const id = String(cartId)
          queryClient.invalidateQueries({ queryKey: ['items', id] })
          queryClient.invalidateQueries({ queryKey: ['carts'] })
          queryClient.refetchQueries({ queryKey: ['items', id] })
          queryClient.refetchQueries({ queryKey: ['carts'] })
        }
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [queryClient])

  return null
}
